<div [class]="labelWrapperClass">
  <label class="control-label" *ngIf="label">{{ label }}</label>
  <div class="d-flex m-1">
    <div *ngIf="helpText" class="me-2 mb-0" data-toggle="tooltip" [title]="helpText">
      <kendo-icon name="info-circle" class="text-secondary"></kendo-icon>
    </div>
    <kendo-switch [checked]="value" (valueChange)="onValueChange($event)" [disabled]="disabled"
      [readonly]="readonly" [onLabel]="onLabel" [offLabel]="offLabel" [size]="size" [tabindex]="tabindex">
    </kendo-switch>
  </div>
</div>